import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { techdocsTranslationRef } from '@backstage/plugin-techdocs/alpha';

/**
 * Every TechDocs text in pt-BR (Story 2.2): the stock index pieces and the
 * reader, which is also the entity Docs tab.
 */
export const techdocsMessages = TranslationBlueprint.make({
  name: 'byx-techdocs',
  params: {
    resource: createTranslationMessages({
      ref: techdocsTranslationRef,
      messages: {
        'search.placeholder': 'Buscar na documentação de {{entityTitle}}',
        'search.noResults': 'Nenhum resultado encontrado',
        'error.couldNotLoad':
          'Não foi possível carregar a documentação disponível.',
        'nav.title': 'Docs',
        'table.columns.type': 'Tipo',
        'table.columns.document': 'Documento',
        'table.columns.kind': 'Tipo de entidade',
        'table.columns.owner': 'Dono',
        'table.body.emptyDataSourceMessage': 'Nada para mostrar',
        'table.header.actions': 'Ações',
        'table.title.all': 'Todos',
        'table.toolbar.searchPlaceholder': 'Filtrar',
        'table.actions.addToFavorites': 'Adicionar aos favoritos',
        'table.actions.removeFromFavorites': 'Remover dos favoritos',
        'table.actions.copyDocsUrl': 'Copiar o link da documentação',
        'table.pagination.labelRowsSelect': 'linhas',
        'table.emptyState.title': 'Nenhum documento para mostrar',
        'table.emptyState.description':
          'Crie a sua documentação. Veja as informações de primeiros passos.',
        'table.emptyState.docsButton': 'Docs',
        'home.supportButton': 'Descubra a documentação do seu ecossistema.',
        'aboutCard.viewTechdocs': 'Ver TechDocs',
        'buildLogs.title': 'Detalhes da geração',
        'buildLogs.closeDrawer': 'Fechar o painel',
        'buildLogs.showBuildLogs': 'Ver logs da geração',
        'buildLogs.waitingForLogs': 'Aguardando os logs…',
        'stateIndicator.initialBuild.message':
          'A documentação está sendo aberta pela primeira vez e está sendo preparada. As próximas aberturas são bem mais rápidas.',
        'stateIndicator.contentStaleRefreshing.message':
          'Uma versão mais nova desta documentação está sendo preparada e logo estará disponível.',
        'stateIndicator.contentStaleReady.message':
          'Uma versão mais nova desta documentação está disponível. Atualize a página para vê-la.',
        'stateIndicator.contentStaleReady.refreshButton': 'Atualizar',
        'stateIndicator.contentStaleError.message':
          'Não foi possível gerar uma versão mais nova desta documentação.',
        'redirectNotification.redirectNow': 'Redirecionar agora',
        'readerPageHeader.source': 'Fonte',
        'readerPageHeader.owner': 'Dono',
        'readerPageHeader.lifecycle': 'Ciclo de vida',
        'pageWrapper.title': 'Documentação',
        'pageWrapper.subtitle': 'Documentação disponível em {{orgName}}',
        'entityContent.title': 'Docs',
        'reader.settings': 'Configurações',
      },
    }),
  },
});
